
import CreateShippingBooking from "../CreateForm/CreateShippingBooking";
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from "../../../components/common/CustomModal";
import { DELETE_IMPORT_SHIPPING_BOOKING, LIST_IMPORT_SHIPPING_BOOKINGS, LIST_PROFORMA_INVOICES_EXPORT } from '../../../services/apiRoutes';
import { costColorPlate, } from '../../../constants/DetailsPage';
import { genericPost } from '../../../services/authServices';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { getCIFFOBList, getCurrencyList, getCustomClearingAgencyData, getDirectListData, getFCLData, getFreightForwardAgencyData, getShippingLines, getCommanExportShipmentId, getPortMasters } from '../../../services/CommonServices';
import UpdateShippingBooking from "../UpdateForm/UpdateShippingBooking";
import ShippingBookingView from "../ViewDetails/ShippingBookingView";
import CustomLoader from "../../common/CustomLoader";
import { AuthContext } from "../../../context/AuthContext";
import BookOnlineOutlinedIcon from '@mui/icons-material/BookOnlineOutlined';
import CustomStatus from "../../common/CustomStatus";
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";


export default function Booking({ fetchButtonList }) {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [open, setOpen] = useState(true);
    const [leadModal, setLeadModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [shippingBookingId, setShippingBookingId] = useState('');
    const [viewModal, setViewModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('Booking');
    const [shippingLines, setShippingLines] = useState([]);
    const [fclData, setFCLData] = useState([]);
    const [directListData, setDirectListData] = useState([]);
    const [freightForwardAgencyData, setFreightForwardAgencyData] = useState([]);
    const [customClearingAgencyData, setCustomClearingAgencyData] = useState([]);
    const [cifFobList, setCIFFOBList] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [proformaInvoiceList, setProformaInvoiceList] = useState([]);
    const [portMasters, setPortMasters] = useState([]);
    const [bookingNumber, setBookingNumber] = useState("");

    const navigate = useNavigate();
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);

    let customerId, cifFob;
    const hasFetched = useRef(false);

    useEffect(() => {
        if (shipmentDetails) {
            customerId = shipmentDetails.customerId;

            cifFob = shipmentDetails.cifFob.cifFobName;
            fetchData();
            getCommonData();
            getProformaInvoice();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, shippingBookingId, token, deleteAlert, leadModal]);


    // const getProformaInvoice = async () => {
    //     try {
    //         const payload = {
    //             customerNamesId: customerId,
    //             shipmentId: shipmentId
    //         };
    //         const response = await genericPost(LIST_PROFORMA_INVOICES_EXPORT, payload, {
    //         });
    //         if (response.data && response.data.success && response.data.data) {
    //             const proform = response.data.data.map((invoice) => ({
    //                 id: invoice.proformaInvExpId || '',
    //                 title: invoice.proformaInvoiceNo || '',
    //             }));
    //             setProformaInvoiceList(proform);
    //         } else {
    //             return [];
    //         }
    //     } catch (error) {
    //         console.error('Error fetching suppliers list:', error);
    //         return [];
    //     }
    // };

    const getProformaInvoice = async () => {
        try {
            const payload = {
                customerNamesId: customerId,
                shipmentId: shipmentId
            };

            const response = await genericPost(LIST_PROFORMA_INVOICES_EXPORT, payload);

            if (response.data && response.data.success && response.data.data) {
                const proform = response.data.data.map((invoice) => {
                    // ✅ Calculate total qty from all particulars
                    const totalQty = invoice.particulars?.reduce((sum, item) => {
                        return sum + Number(item.qty || 0);
                    }, 0);

                    return {
                        id: invoice.proformaInvExpId || '',
                        title: invoice.proformaInvoiceNo || '',
                        totalQty: totalQty,
                    };
                });

                setProformaInvoiceList(proform);
            } else {
                setProformaInvoiceList([]);
            }
        } catch (error) {
            console.error('Error fetching proforma invoices:', error);
            setProformaInvoiceList([]);
        }
    };


    const formatPortName = (port, country) => {
        return [port, country].filter(Boolean).join(", ");
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: customerId,
                commanShipmentId: getCommanExportShipmentId,
                shipmentId: shipmentId,

            };
            const response = await genericPost(LIST_IMPORT_SHIPPING_BOOKINGS, payload, {
            });

            if (response.data.success && response.data.shippingBooking) {
                const shippingBookingData = response.data.shippingBooking.map((booking, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    shippingBookingId: booking.shippingBookingId || '',
                    shipmentId: booking.shipmentId || '',
                    portOfLoading: booking.portOfLoading || '',
                    portOfDestination: booking.portOfDestination || '',
                    etaDate: companyDateFormat(booking?.etaDate) || '',
                    etdDate: companyDateFormat(booking?.etdDate) || '',
                    proformaInvoiceNo: booking?.ProformaInvExp?.proformaInvoiceNo || '',
                    conversionRate: `${booking?.baseCurrency?.currency_symbol || ''} ${booking.conversionRate || ''}`,
                    numberOfContainers: booking.numberOfContainers || '',
                    cifFobId: booking.cifFob?.cifFobId || '',
                    cifFobName: booking.cifFob?.cifFobName || '',
                    cifFob: booking.cifFob?.cifFobName || '',
                    shippingLineName: booking.shippingLines?.shippingLineName || '',
                    agencyName: booking.freightForwardAgency?.agencyName || '',
                    chaName: booking.customClearingAgency?.chaName || '',
                    bookingNumber: booking.bookingNumber || '',
                    blCharges: `${booking?.baseCurrency?.currency_symbol || ''} ${booking.blCharges || ''}`,
                    destinationCharges: `${booking?.baseCurrency?.currency_symbol || ''} ${booking.destinationCharges || ''}`,
                    shippingLineCharges: `${booking?.baseCurrency?.currency_symbol || ''} ${booking.shippingLineCharges || ''}`,
                    seaFreight: `${booking?.currency?.currency_symbol || ''} ${booking.seaFreight || ''}`,
                    shippingLineColor: booking.shippingLines?.ColorPlate?.color || '',
                    shippingLineBg: booking.shippingLines?.ColorPlate?.backgroundColor || '',
                    agencyColor: booking.freightForwardAgency?.ColorPlate?.color || '',
                    agencyBg: booking.freightForwardAgency?.ColorPlate?.backgroundColor || '',
                    chaColor: booking.customClearingAgency?.ColorPlate?.color || '',
                    chaBg: booking.customClearingAgency?.ColorPlate?.backgroundColor || '',
                    qty: booking.qty || '',
                    perContainer: booking.perContainer || '',
                    loadingName: formatPortName(
                        booking?.loading?.portName,
                        booking?.loading?.country?.name
                    ),
                    destinationName: formatPortName(
                        booking?.destination?.portName,
                        booking?.destination?.country?.name
                    ),
                }));
                setData(shippingBookingData);
                setBookingNumber(response.data.newBookingNumber || "");
            } else {
                setError('No shipping bookings found');
            }
        } catch (error) {
            setError('Error fetching shipping bookings');
            console.error('Error fetching shipping bookings', error);
        } finally {
            setLoading(false);
        }
    };


    if (!shipmentDetails) {
        return <p> <CustomLoader open={shipmentLoading} /> </p>;
    }

    const handleDelete = async (shippingBookingId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_IMPORT_SHIPPING_BOOKING(shippingBookingId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                fetchButtonList();
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    const getCommonData = async () => {
        const shippingLines = await getShippingLines();
        setShippingLines(shippingLines);
        const fclData = await getFCLData();
        setFCLData(fclData);
        const directListData = await getDirectListData();
        setDirectListData(directListData);
        const freightForwardAgencyData = await getFreightForwardAgencyData();
        setFreightForwardAgencyData(freightForwardAgencyData);
        const customClearingAgencyData = await getCustomClearingAgencyData();
        setCustomClearingAgencyData(customClearingAgencyData);
        const cifFobListData = await getCIFFOBList();
        setCIFFOBList(cifFobListData);
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
        const getPortMastersData = await getPortMasters()
        setPortMasters(getPortMastersData)

    }

    const handleOpen = () => {
        setLeadModal(true);
    };

    const handleClose = () => {
        setLeadModal(false);
    };


    const handleUpdateClick = (id) => {
        setShippingBookingId(id);
        setUpdateModal(true);
    };


    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setShippingBookingId('');
    };

    const handleViewClick = (id) => {
        setShippingBookingId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setShippingBookingId('');
    };



    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }

    const ShippingBookingCardColumns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            accessor: 'bookingNumber', label: 'Booking Number', id: 'bookingNumber', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'shipmentId', label: 'Shipment ID', id: 'shipmentId', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            accessor: 'proformaInvoiceNo', label: 'proforma Invoice', id: 'shipmentId', styleAccessor: {
                textAlign: 'center'
            },
        },
        { accessor: 'loadingName', label: 'Port Of Loading', id: 'lp' },
        { accessor: 'destinationName', label: 'Port Of Destination', id: 'dp' },
        {
            accessor: 'etdDate', label: 'ETD Date', id: 'etdDate', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            accessor: 'etaDate', label: 'ETA Date', id: 'etaDate', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'cifFob',
            label: 'CIF/FOB',
            accessor: 'cifFob',
            styleAccessor: { textAlign: 'center' },
            Cell: ({ row }) => {
                const colorConfig = costColorPlate.find(
                    (color) => color.colorId === row.cifFobId
                ) || {
                    backgroundColor: "#ffffff",
                    color: "#000000",
                };
                return (
                    <CustomStatus
                        title={row.cifFobName}
                        sx={{
                            backgroundColor: colorConfig.backgroundColor,
                            color: colorConfig.color,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },
        {
            accessor: 'seaFreight', label: 'Sea Freight', id: 'seaFreight', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'destinationCharges', label: 'Others Charges', id: 'destinationCharges', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'shippingLineCharges', label: 'Shipping Line Charges', id: 'shippingLineCharges', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'blCharges', label: 'BL Charges', id: 'blCharges', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'conversionRate', label: 'Conversion Rate', id: 'conversionRate', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            accessor: 'qty', label: 'Quantity', id: 'qty', styleAccessor: {
                textAlign: 'center'
            },
        },
        {
            accessor: 'perContainer', label: 'Per Container', id: 'perContainer', styleAccessor: {
                textAlign: 'center'
            },
        },

        {
            accessor: 'numberOfContainers', label: 'No. of Containers', id: 'numberOfContainers', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            accessor: 'shippingLineName', label: 'Shipping Line', id: 'shippingLineName',
            styleAccessor: { textAlign: 'center' },
            Cell: ({ row }) => {
                return (
                    <CustomStatus
                        title={row.shippingLineName}
                        sx={{
                            backgroundColor: row.shippingLineBg,
                            color: row.shippingLineColor,
                            border: `1px solid ${row.shippingLineColor}`,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },
        {
            accessor: 'agencyName', label: 'Freight Forward Agency', id: 'agencyName',
            styleAccessor: { textAlign: 'center' },
            Cell: ({ row }) => {
                return (
                    <CustomStatus
                        title={row.agencyName}
                        sx={{
                            backgroundColor: row.agencyBg,
                            color: row.agencyColor,
                            border: `1px solid ${row.agencyColor}`,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },
        {
            accessor: 'chaName', label: 'Clearing Agency (CHA)', id: 'chaName',
            styleAccessor: { textAlign: 'center' },
            Cell: ({ row }) => {
                return (
                    <CustomStatus
                        title={row.chaName}
                        sx={{
                            backgroundColor: row.chaBg,
                            color: row.chaColor,
                            border: `1px solid ${row.chaColor}`,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },

        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.shippingBookingId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.shippingBookingId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.shippingBookingId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];

    const companyName = shipmentDetails.customer.clientCompanyName;
    const phoneNumber = shipmentDetails.customer.mobile;
    const cifFobId = shipmentDetails.cifFobId;
    const customerName = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const currencySymbol = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
    const baseCurrencyId = shipmentDetails?.company?.baseCurrencyData?.id ?? '';
    const currencyId = shipmentDetails.currencyId;
    const currencySym = shipmentDetails?.currency?.currency_symbol ?? '';
    const shipmentOrgId = shipmentDetails.exportShipmentId;
    const portOfLoading = shipmentDetails.portOfLoading ?? "";
    const portOfDestination = shipmentDetails.portOfDestination ?? "";

    return (
        <div>

            <CustomLoader open={loading} />
            <DetailsPageCard
                Icon={BookOnlineOutlinedIcon}
                columns={ShippingBookingCardColumns}
                title={'Shipping Booking'}
                buttonTitle={'Create Booking'}
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={leadModal}  >
                <CreateShippingBooking
                    fetchData={fetchData}
                    clientCompanyId={customerName}
                    shippingLines={shippingLines}
                    shipmentId={shipmentId}
                    commanShipmentId={getCommanExportShipmentId}
                    fclData={fclData}
                    directListData={directListData}
                    freightForwardAgencyData={freightForwardAgencyData}
                    customClearingAgencyData={customClearingAgencyData}
                    cifFobList={cifFobList}
                    currencyList={currencyList}
                    currencyId={currencyId}
                    currencySym={currencySym}
                    currencySymbol={currencySymbol}
                    baseCurrencyId={baseCurrencyId}
                    cifFobId={cifFobId}
                    shipmentOrgId={shipmentOrgId}
                    setMessage={setMessage}
                    handleClose={handleClose}
                    fetchButtonList={fetchButtonList}
                    portOfLoading={portOfLoading}
                    portOfDestination={portOfDestination}
                    portMasters={portMasters}
                    proformaInvoiceList={proformaInvoiceList}
                    bookingNumber={bookingNumber}
                />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdateShippingBooking
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    shippingBookingId={shippingBookingId}
                    clientCompanyId={customerName}
                    shippingLines={shippingLines}
                    fclData={fclData}
                    directListData={directListData}
                    freightForwardAgencyData={freightForwardAgencyData}
                    customClearingAgencyData={customClearingAgencyData}
                    cifFobList={cifFobList}
                    currencyList={currencyList}
                    portMasters={portMasters}
                    proformaInvoiceList={proformaInvoiceList}
                />
            </CustomModal>

            <CustomModal
                modalStyles={{
                    maxHeight: '70vh',
                    top: "10%",
                }}
                open={viewModal} handleClose={handleCloseView}>
                <ShippingBookingView
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleCloseView}
                    shippingBookingId={shippingBookingId}
                    clientCompanyId={customerName}
                    shippingLines={shippingLines}
                    fclData={fclData}
                    directListData={directListData}
                    freightForwardAgencyData={freightForwardAgencyData}
                    customClearingAgencyData={customClearingAgencyData}
                    cifFobList={cifFobList}
                    currencyList={currencyList}
                />
            </CustomModal>
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
}
